import React, { Component } from 'react'
import { Row, Field, Label, Button }  from '../../generic'
import TextInput from '../../generic/fields/TextInput'
import Uploader from '../../generic/fields/Uploader'
import { word_wrap } from '../../../helpers/check-required-fields'
import Preview from '../preview/Graphic'
import styled from 'styled-components'
import example1 from '../../../images/19_OTT_Invitationexample-01.jpg'
import example2 from '../../../images/19_OTT_Invitationexample-02.jpg'
import example3 from '../../../images/19_OTT_Invitationexample-03.jpg'
import hazard from '../../../images/hazard-red.png'

const TOPIC_LIMIT = 4

const Hint = styled.div`
  color: rgba(0,0,0,0.6);
  margin-top: 7px;
  margin-bottom: 7px;
`

const GraphicExamples = styled.div`
  overflow-x: scroll;
  margin-bottom: 16px;

  img {
    width: calc(50% - 8px);
    @media (min-width: 600px) {
      width: calc(33% - 8px);
    }
    height: auto;
    margin-right: 8px;
  }
`

class Graphic extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showExamples: false,
    }
    this.toggleExamples = this.toggleExamples.bind(this)
  }

  toggleExamples() {
    this.setState({
      showExamples: !this.state.showExamples
    })
  }

  render() {
    const { userEvent, onChange } = this.props
    const numLines = word_wrap(userEvent.topic || '', 20).split("\n").length
    const topicInvalid = userEvent.topic && numLines > TOPIC_LIMIT
    return (
      <React.Fragment>
        <Row>
          <h2>Event Introduction</h2>
          <p>On the Table is a chance to talk about something important to you and your guests. Create your invitation by saying what you'd like to focus on.</p>
          <p><a onClick={this.toggleExamples}>{this.state.showExamples ? "Hide" : "See"} Examples</a></p>
          {this.state.showExamples &&
            <GraphicExamples>
              <img src={example1} />
              <img src={example2} />
              <img src={example3} />
            </GraphicExamples>
          }
          <div style={{ maxWidth: '350px', marginBottom: '20px', border: '5px solid #eee' }}><Preview userEvent={userEvent} /></div>
          <Field name="userEvent[topic]" error={topicInvalid} hint={(<div style={topicInvalid ? {color: '#f00'} : {}}>{topicInvalid && <img style={{marginRight: '8px'}} width="15px" height="15px" src={hazard}/>}{userEvent.topic ? numLines : 0} / {TOPIC_LIMIT} lines. Be brief, you can expand your topic in the Invitation Message.</div>)}>
            <Label value="What will you be talking about?" required={true} />
            <TextInput autoFocus="true" value={userEvent.topic} onChange={onChange} />
          </Field>
          <Field style={{marginBottom: '35px'}} name="userEvent[invitation_logo]" error={false}>
            <Label value="Optional: upload a logo image (less than 2MB)" />
            <Hint>JPG or PNG file only</Hint>
            <Uploader value={userEvent.invitation_logo} onChange={onChange} />
          </Field>
        </Row>
      </React.Fragment>
    )
  }
}

export default Graphic
